import type { LucideIcon } from 'lucide-react';

import { Card, CardContent } from '@pesto/ui/components/Card';
import { Typography } from '@pesto/ui/components/Typography';

export interface EntityEmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
}

export const EntityEmptyState = ({ icon: Icon, title, description }: EntityEmptyStateProps) => (
  <Card>
    <CardContent className="flex flex-col items-center justify-center gap-2 py-12">
      {Icon && <Icon className="text-muted-foreground/60 h-8 w-8" />}
      <Typography variant="body" className="text-muted-foreground">
        {title}
      </Typography>
      {description && (
        <Typography variant="caption" className="text-muted-foreground/80 text-center">
          {description}
        </Typography>
      )}
    </CardContent>
  </Card>
);
